/**
 * @desc sku校验
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/warehouseRules/skuCheck`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
